<!-- 我要提现 -->
<template>
  <div class="view-container">
    <!-- 左边 -->
    <div class="view-container-left">
      <div class="el-form-item">
        <div class="el-form-item__label">可提现余额：</div>
      </div>
      <div class="el-form-item">
        <div class="el-form-item__label">收款人：</div>
      </div>
      <div class="el-form-item">
        <div class="el-form-item__label">提现方式：</div>
      </div>
      <div class="el-form-item">
        <div class="el-form-item__label">账号选择：</div>
      </div>
      <div class="el-form-item">
        <div class="el-form-item__label">提现金额：</div>
      </div>
      <div class="el-form-item">
        <div class="el-form-item__label">交易密码：</div>
      </div>
    </div>
    <!-- 右边 -->
    <div class="view-container-right">
      <div class="el-form-item">
        <div class="able-money">¥{{userData.canWithdrawBalance}}</div>
      </div>
      <div class="el-form-item">
        <div class="el-form-item__label">{{userData.name}}</div>
        <img src="../../assets/image/renzheng.png" alt="" />
      </div>

      <div class="el-form-item" style="position: relative">
        <el-select
          v-model="form.accType"
          placeholder="请选择方式"
          style="width: 350px"
          @change="handleChange"
        >
          <el-option
            v-for="item in type"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          
          >
          </el-option>
        </el-select>
        <!-- <div class="el-form-item-abs1">· 单笔提款限额50000元</div> -->
      </div>
      <div class="el-form-item">
        <el-select
          v-model="form.accId"
          placeholder="请选择账号"
          style="width: 350px"
        >
          <el-option
            v-for="item in accountlist"
            :key="item.accId"
            :label="item.account"
            :value="item.accId"
          
          >
          </el-option>
        </el-select>
        <span class="suffix" @click="withdrawClick(5.5)">{{accountlist.length > 0 ? '选择账号' : '添加账号'}}</span>
      </div>
      <div class="el-form-item" style="position: relative">
        <el-input
          v-model="form.amount"
          style="width: 350px"
          placeholder="请输入提现金额"
        >
        </el-input>
        <span class="suffix" @click="allClick" style="z-index: 999;">全部提现</span>
        <div class="el-form-item-abs2" v-if="tip">
          <div style="display: flex; margin-top: 5px;" v-if="tip">
            <div style="margin-right: 3px;">·</div>
            <div v-html="tip">
          </div>
          </div>
       
        </div>
      </div>
      <div class="el-form-item">
        <el-input
          v-model="form.fundPwd"
          style="width: 350px"
          placeholder="请输入交易密码"
        >
        </el-input>
        <span class="suffix" style="margin-left: -105px" @click="withdrawClick(5.33)"> {{!this.userData.isSetFundPassWord?'设置':'修改'}}交易密码</span>
      </div>
      <el-button type="primary"  @click="withdrawal">立即提现</el-button>
    </div>
  </div>
</template>

<script>
import http from "@/utils/http/axios";
export default {
  data() {
    return {
      form: {
        amount:0
      },
      type: [],
      tip:'',
      accountlist:[],
      userData:''
      
    };
  },
  methods: {
    handleChange(value){
      this.tip = this.type[value-1].tip;
    },
    // 全部提现
    allClick(){
      if(this.userData.balance == 0){
        this.$message.error("当前余额为0，无法提现");
        return;
      }
      this.form.amount = this.userData.balance;
    },
       withdrawClick(vl){
        window.scrollTo(0, 0); 
        localStorage.removeItem('tab')
        let  v = vl
        if(vl==5.33){
          v = 5.3;
          localStorage.setItem('tab', "2");
        }
        this.$emit('withdrawClick',v)
      },

      // 获取用户信息
      getUserInfo() {
      http
        .get("/user/base/info")
        .then((response) => {
          if (response.code === 200) {
            this.userData = response.data;
            console.log(  this.userData);
            
          }
        })
        .catch((error) => {
          this.$message.error("发生意外异常");
        });
    },
    onSubmit() {
      console.log("submit!");
    },
    //提现方式
    typeWithdrawal() {
      http
        .get("/withdrawal/type")
        .then((response) => {
          if (response.code == 200) {
            this.type = response.data;
          }
        })
        .catch((error) => {
          this.$message.error("发生意外异常");
        });
    },
    //提现账户列表
    accountList(){
      http
        .get("/user/account/list?accType=1")
        .then((response) => {
          if (response.code == 200) {
            this.accountlist = response.data;
          }else{
            this.$message.error(response.msg);

          }
        })
    },
    // 用户提现
    withdrawal(){
    if(!this.form.accType|| !this.form.accId||!this.form.amount||!this.form.fundPwd){
      this.$message.error("页面数据不完整");
      return;
    }
    http
        .post("/user/account/withdrawal",this.form)
        .then((response) => {
          console.log(response);
          if (response.code == 200) {
            this.form.amount = "";
            this.form.fundPwd = "";
          }else{
            this.$message.error(response.msg);
          }
        })
    }
  },
  mounted() {
    this.typeWithdrawal();
    this.accountList()
    this.getUserInfo()
  },
};
</script>

<style lang="less" scoped>
.view-container {
  background-color: white;
  height: 100%;
  padding-top: 100px;
  padding-right: 20px;
  display: flex;
  position: relative;

  .el-form-item-abs1 {
    position: absolute;
    top: 0;
    left: 380px;
    background-color: rgb(254, 244, 222);
    height: 40px;
    line-height: 40px;
    padding: 0 15px;
    width: 370px;
    font-size: 12px;
    box-sizing: border-box;
    border-radius: 10px;
    color: #a95300;
    max-width: calc(100% - 400px);
    margin-right: 20px;
  }

  .el-form-item-abs2 {
    position: absolute;
    height: auto;
    left: 380px;
    background-color: rgb(254, 244, 222);
    width: 370px;
    max-width: calc(100% - 400px);
    display: flex;
    flex-direction: column;
    padding: 15px;
    justify-content: center;
    font-size: 12px;
    color: #a95300;
    box-sizing: border-box;
    border-radius: 10px;
    margin-right: 20px;

    @media screen and (max-width: 1200px) {
      width: 300px;
    }
  }

  .el-form-item {
    height: 40px;
    display: flex;
    align-items: center;

    img {
      width: 18px;
      height: 18px;
    }
  }
  .el-form-item__label {
    color: #000000e0;
    font-size: 16px;
    font-weight: 400;
  }
  .view-container-left {
    width: 200px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }
  .view-container-right {
    flex: 1;
    .able-money {
      color: #ffbd00;
      font-size: 24px;
      font-weight: 500;
      padding-left: 12px;
    }
  }
}
.suffix {
  margin-left: -75px; /* 与输入框间隔 */
  z-index: 99;
  color: #488eff;
}
</style>